import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "500px",
    height: "231px",
    borderRadius: "20px",
    padding: "24px",
    backgroundColor: "#1B1D28",
  },
  outlineButton: {
    width: "150px",
    color: `${theme.palette.text.primary} !important`,
    border: `2px solid ${theme.palette.secondary.main} !important`,
    borderRadius: "10px",
    padding: "6px 16px !important",
    textAlign: "center !important",
    marginRight: "8px !important",
    textTransform: "none !important",
    "&:hover": {
      backgroundColor: `${theme.palette.secondary.light} !important`,
    },
  },
  filledButton: {
    width: "180px",
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: `${theme.palette.text.secondary} !important`,
    borderRadius: "10px",
    padding: "6px 16px !important",
    textAlign: "center !important",
    marginRight: "8px !important",
    textTransform: "none !important",
    "&:hover": {
      backgroundColor: `${theme.palette.secondary.light} !important`,
    },
  },
  infoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
  },
  endContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export default useStyles;
